import Tab from "@mui/material/Tab";
import { ScrollableTabs } from "_shared/_views/tables/table-toolbar";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material";
import ActiveTeams from "_shared/teams/teams-active-page";
import { PageTab } from "_shared/teams/teams-tabs";
import TeamsTemplatesPage from "_shared/teams/teams-templates-page";
import React, { useEffect } from "react";
import { useLoaderData, useNavigate } from "react-router";

export const ToolbarButtonsContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  display: "flex",
  alignItems: "end",
  flexDirection: "column",
  gap: theme.spacing(1),
}));
// The three rules below are what let this toolbar fit a phone, and they only work together — the
// same arrangement the work agreements page uses. A flex item defaults to `min-width: auto`, which
// is its content's width, so the tab strip otherwise holds the toolbar open at the width of its
// four labels; MRT's top toolbar is a grid with `overflow-x: hidden`, so everything to the right of
// the tabs is then clipped away with no scrollbar to suggest it is there.
export const TableTopToolbarContainer = styled("div")(() => ({
  display: "flex",
  flex: "1 1 0",
  flexDirection: "column",
  maxWidth: "100%",
  minWidth: 0,
  width: "100%",
}));
export const LowerTopToolbarContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
  display: "flex",
  flexDirection: "row",
  alignItems: "left",
  minWidth: 0,
  width: "100%",
}));
export const TableTitle = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
}));
export const RowTitle = styled(Typography)(() => ({
  fontSize: "1.1em",
  fontWeight: "600",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

export function TeamsTabs({ activeTab }: Readonly<{ activeTab: PageTab }>) {
  const navigate = useNavigate();
  return (
    <ScrollableTabs
      value={activeTab}
      indicatorColor="primary"
      textColor="primary"
      // The four labels measure ~550px together, wider than a phone. Scrollable lets the strip take
      // the space it has and scroll the rest, rather than holding the whole toolbar open.
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      onChange={(_event, newValue) => navigate(`/teams/${newValue}/`)}
    >
      <Tab value={PageTab.Templates} label="Templates" />
      <Tab value={PageTab.TeamsOn} label="Teams I'm On" />
      <Tab value={PageTab.TeamsWorkingForMe} label="Teams Working For Me" />
      <Tab value={PageTab.Archived} label="Archived" />
    </ScrollableTabs>
  );
}

export default function Teams() {
  const routeParams = useLoaderData();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!routeParams?.pageTab) {
      navigate("/teams/templates/");
    }
  }, [routeParams, navigate]);

  if (routeParams?.pageTab === PageTab.Templates || routeParams?.pageTab === PageTab.Archived) {
    return <TeamsTemplatesPage />;
  }

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <ActiveTeams />
    </React.Suspense>
  );
}
